/**
 * Opengater gifts hooks (users service, `admin: gifts`): money a mailing hands
 * out by a button. There is no delete — a gift past its last day just stops.
 * The list paginates; gifts are few, so one page of the largest size is enough.
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiOg } from './client';
const PATH = '/api/v1/admin/gifts';
const KEY = ['og', 'gifts'];
const PAGE = 200;
export function useOgGifts() {
    return useQuery({
        queryKey: KEY,
        queryFn: () => apiOg('users', `${PATH}?limit=${PAGE}&offset=0`),
    });
}
export function useCreateOgGift() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (body) => apiOg('users', PATH, { method: 'POST', body }),
        onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
    });
}
export function useUpdateOgGift() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ id, patch }) => apiOg('users', `${PATH}/${id}`, { method: 'PATCH', body: patch }),
        onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
    });
}
